/* eslint-disable camelcase */
import React, { useContext, useState } from 'react';
import { isEmpty, omitBy } from 'lodash';
import { useRouter } from 'next/router';
import { stringify } from 'query-string';

import { SearchContext } from 'components/views/search/context/SearchContext';
import {
  SET_AUTOCOMPLETE_PANEL_ACTIVE,
  SET_FETCHED_AUTOCOMPLETE,
} from 'components/views/search/reducer/index';
import { getFromChownowApi } from 'helpers/api';
import formatAutocomplete from 'helpers/format';

import SearchOverlay from 'components/views/search/components/SearchOverlay/SearchOverlay';
import RestaurantAndCuisineSearch from '../RestaurantAndCusineSearch/RestaurantAndCuisineSearch';

export default function AutocompleteWrapper() {
  const {
    state: { autocompletePanelActive, searchFiltersFromURL, geocodedSearchedAddress },
    dispatchToReducer,
  } = useContext(SearchContext);
  const router = useRouter();
  const [showCuisines, setShowCuisines] = useState(true);
  const searchValue = searchFiltersFromURL.query;

  function handleOverlayStateChange(state) {
    dispatchToReducer({ type: SET_AUTOCOMPLETE_PANEL_ACTIVE, payload: state });
  }

  async function handleAutocompleteChange(e) {
    const query = e.target.value;
    setShowCuisines(e.target.value?.length === 0);
    dispatchToReducer({
      type: SET_FETCHED_AUTOCOMPLETE,
      payload: { isLoading: true, results: null },
    });

    // Update URL to reflect query
    const searchParams = router?.query;
    if (searchParams.cuisines) delete searchParams.cuisines;

    router.push({
      pathname: 'search',
      search: stringify({ ...searchParams, query }),
    });

    // Build the payload to send the query to the API
    const currentLocation = searchFiltersFromURL;
    const customerGeo = geocodedSearchedAddress;

    const lat = currentLocation.lat || customerGeo.lat;
    const lng = currentLocation.lng || customerGeo.lng;

    const { data } = await getFromChownowApi(
      `autocomplete?query=${query}&u_lat=${lat}&u_lon=${lng}`
    );
    const response = {
      isLoading: false,
      results: formatAutocomplete(data),
    };

    if (data) {
      dispatchToReducer({
        type: SET_FETCHED_AUTOCOMPLETE,
        payload: response,
      });
    }
  }

  function handleTileClick(cuisine) {
    setShowCuisines(true);
    handleOverlayStateChange(false);
    const searchParams = router?.query;
    // American is not a cuisine types, so we do not use the cuisines param for that tile
    const cuisineParam = cuisine === 'American' ? '' : cuisine;

    // The query param updates the search term
    router.push({
      pathname: 'search',
      search: stringify({ ...searchParams, cuisines: cuisineParam, query: cuisine }),
    });
  }

  function handleAutocompleteSearch(value) {
    const searchParams = router?.query;
    const query = omitBy(
      {
        ...searchParams,
        // a new restaurant search should clear cuisines
        cuisines: '',
        ...value,
      },
      isEmpty
    );
    router.push({
      pathname: 'search',
      search: stringify(query),
    });
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (!autocompletePanelActive) return;

    if (!searchValue) {
      // Reset search term
      const searchParams = router?.query;
      router.push({
        pathname: 'search',
        search: stringify({ ...searchParams, query: '' }),
      });
      dispatchToReducer({
        type: SET_FETCHED_AUTOCOMPLETE,
        payload: { isLoading: false, results: null },
      });
    }

    const currentQuery = searchValue;

    handleAutocompleteSearch(currentQuery);
  }

  return (
    <>
      <RestaurantAndCuisineSearch
        onAutocompleteChange={handleAutocompleteChange}
        onSubmit={handleSubmit}
      />
      {autocompletePanelActive && (
        <SearchOverlay
          onAutocompleteChange={handleAutocompleteChange}
          onAutocompleteSearch={handleAutocompleteSearch}
          onSubmit={handleSubmit}
          onTileClick={handleTileClick}
          showCuisines={showCuisines}
        />
      )}
    </>
  );
}
